import React, { Suspense, useEffect, useState,lazy } from 'react'
import { useMediaQuery } from 'react-responsive';
// import ResponsiveCardList from './ResponsiveCardList';
// import ResponsiveTable from './ResponsiveTable';
import ResumenPago from './ResumenPago';
import BienvenidoCliente from './BienvenidoCliente';
const ResponsiveCardList = lazy(() => import('./ResponsiveCardList'));
const ResponsiveTable = lazy(() => import('./ResponsiveTable'));

const SeleccionPoliza = ({
  ...props // step, stepForward, stepBackwards
}) => {

    // const dispatch = useDispatch()
  const isMobile = useMediaQuery({ maxWidth: 768 });
  // const { polizas: todasPolizas } = useSelector(state => state.poliza)

  // Estado para controlar el tipo de vista
  const [viewType, setViewType] = useState(isMobile ? 'mobile' : 'desktop');
  const [key, setKey] = useState(0); // Forzar remount

  useEffect(() => {
    const newView = isMobile ? 'mobile' : 'desktop';
    if (newView !== viewType) {
      setViewType(newView);
      setKey(prev => prev + 1); // Cambia el key => React remonta el componente
    }
  }, [isMobile, viewType]);

  

  return (
    <>
     <ResumenPago {...props}  fixed={isMobile} />
    <BienvenidoCliente {...props}  fixed={isMobile} />
    <Suspense fallback={<div>Cargando vista...</div>}>
        {
          isMobile
          ? <ResponsiveCardList {...props} key={key}  fixed={isMobile} />
          : <ResponsiveTable {...props} key={key} />
        }
    </Suspense>
    </>
  )
}

export default SeleccionPoliza